import './js/legal';